package ui.screens

import CompassDivider
import androidx.compose.animation.AnimatedVisibilityScope
import androidx.compose.animation.ExperimentalSharedTransitionApi
import androidx.compose.animation.core.LinearOutSlowInEasing
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.tween
import androidx.compose.foundation.ExperimentalFoundationApi
import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.zIndex
import data.repository.FirebaseInvitationRepo
import dev.gitlive.firebase.database.DataSnapshot
import kotlinx.coroutines.delay
import models.ScrollSnapshot
import models.UiScrollState
import models.getUnduhMantu
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import thewedding_cmp.composeapp.generated.resources.Res
import thewedding_cmp.composeapp.generated.resources.background_flower
import thewedding_cmp.composeapp.generated.resources.background_grass
import thewedding_cmp.composeapp.generated.resources.icon_next
import thewedding_cmp.composeapp.generated.resources.photo_2
import thewedding_cmp.composeapp.generated.resources.photo_3
import thewedding_cmp.composeapp.generated.resources.photo_4
import thewedding_cmp.composeapp.generated.resources.semanticsNext
import ui.composables.AppIconButton
import ui.composables.InfoTitle
import ui.composables.WeddingFloatingButton
import ui.composables.firstItemScrollProgress
import ui.composables.scrollProgressFor
import ui.composables.surfaceItem
import ui.enums.InfoSection
import ui.screens.section.brideandgroom.BrideAndGroomSection
import ui.screens.section.footer.WeddingClosing
import ui.screens.section.gallery.ParallaxImages
import ui.screens.section.gallery.RomanticGalleryButton
import ui.screens.section.hero.HeroSection
import ui.screens.section.weddinginfo.CountdownWedding
import ui.screens.section.weddinginfo.PullQuote1
import ui.screens.section.weddinginfo.WeddingTitle
import ui.screens.section.welcome.WeddingWelcomeSection
import ui.screens.section.wishesandgift.WishesSection
import ui.screens.section.wisheslist.WishesListSection
import ui.theme.bgColor
import utils.AudioPlayer
import kotlin.time.ExperimentalTime

@OptIn(
    ExperimentalFoundationApi::class,
    ExperimentalSharedTransitionApi::class, ExperimentalTime::class
)
@Composable
fun WeddingScreen(
    backToGate: () -> Unit,
    openNotInvitedScreen: () -> Unit,
    openGalleryScreen: () -> Unit,
    audioPlayer: AudioPlayer,
    animatedVisibilityScope: AnimatedVisibilityScope,
    invitationRepo: FirebaseInvitationRepo,
    invitationName: String,
    maxWidth: Dp,
    modifier: Modifier,
) = Box(modifier = modifier) {
    var uiReady by remember {
        mutableStateOf(false)
    }
    val entered = remember { mutableStateOf(false) }
    LaunchedEffect(Unit) {
        // kasih waktu 1 frame
        delay(32)
        uiReady = true
        entered.value = true
    }

    val textColor = Color(0xff323232)

    // Shows home screen when the user has over-scrolled enough to top

    val safeEntered = uiReady && entered.value
    val bgPainter = painterResource(Res.drawable.background_flower)
    var nameInvited by remember { mutableStateOf<DataSnapshot?>(null) }
    LaunchedEffect(uiReady) {
        if (uiReady) {
            invitationRepo.checkInvitationByName(invitationName).collect {
                nameInvited = it
            }
        }
    }
    val opened = rememberSaveable(invitationName) { mutableStateOf(false) }
    val scrollState = rememberLazyListState()
    val scrollSnapshot by remember(uiReady, scrollState) {
        derivedStateOf {
            if (!uiReady) {
                ScrollSnapshot()
            } else {
                val layoutInfo = scrollState.layoutInfo
                ScrollSnapshot(
                    index = scrollState.firstVisibleItemIndex,
                    offset = (scrollState.firstVisibleItemScrollOffset / 20) * 20,
                    viewportHeightPx = layoutInfo.viewportSize.height,
                    visibleItems = layoutInfo.visibleItemsInfo
                )
            }
        }
    }
//
//    val visibleItemIndex by produceState(0) {
//        snapshotFlow { scrollState.firstVisibleItemIndex }
//            .collect { value = it }
//    }

    val visibleItemIndex by remember {
        derivedStateOf {
            scrollSnapshot.index
        }
    }

    val uiScrollState by remember {
        derivedStateOf {
            UiScrollState(
                index = scrollSnapshot.index,
                firstItemProgress = scrollSnapshot.firstItemScrollProgress
                    .let { (it * 10).toInt() / 10f } // quantize lebih kasar
            )
        }
    }

    val parallaxProgress by remember {
        derivedStateOf {
            scrollSnapshot.scrollProgressFor(3)
        }
    }

    val showGalleryBg = scrollSnapshot.index >= 2

    LaunchedEffect(nameInvited) {
        nameInvited?.let {
            if (!opened.value) {
                opened.value = true
                println("Editorial, Nama undangan ${it.key}, exists ${it.exists}")
                if (!it.exists) {
                    openNotInvitedScreen()
                }
            }
        }
    }

    Image(
        painterResource(Res.drawable.background_flower),
        contentDescription = null,
        Modifier.fillMaxSize(),
        contentScale = ContentScale.FillWidth
    )

    // background and hero image
    val bgAlpha1 by remember {
        derivedStateOf { scrollSnapshot.firstItemScrollProgress }
    }

    Box(Modifier.fillMaxSize()) {
        HeroSection(safeEntered, bgAlpha1, animatedVisibilityScope, bgPainter)
    }

    Box(Modifier.fillMaxSize()) {
        // Fade in/out transisi lembut
        val bgAlpha by animateFloatAsState(
            targetValue = if (showGalleryBg) 1f else 0f,
            animationSpec = tween(durationMillis = 1000, easing = LinearOutSlowInEasing)
        )

        Image(
            painter = painterResource(Res.drawable.background_grass),
            contentDescription = null,
            modifier = Modifier
                .matchParentSize()
                .graphicsLayer { alpha = bgAlpha },
            contentScale = ContentScale.Crop,
        )

        // 🧱 Konten utama (LazyColumn)
        // Main content
        LazyColumn(
            modifier = Modifier.fillMaxSize(), // GANTI
            state = scrollState
        ) {
            // Wedding Welcome
            // 0
            item {
//                val titleAlpha = 1f - uiScrollState.firstItemProgress
//                val titleTranslationY = uiScrollState.firstItemProgress * 300
                Column(
                    Modifier.fillMaxWidth()
                        .padding(top = 280.dp, bottom = 16.dp)
                        .zIndex(0.1f),
//                        .alpha(titleAlpha)
//                        .offset { IntOffset(0, titleTranslationY.toInt()) },
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    WeddingWelcomeSection(textColor, safeEntered, scrollSnapshot)
                }
            }
            // Bride And Groom
            // 1
            item {
                val imageHeight = minOf(600.dp, maxWidth)
                val imageWidth = minOf(imageHeight / 1.5f, maxWidth / 1.5f)
                val decorationSize = imageHeight / 4
                val decorationSizeX2 = decorationSize * 2
                BrideAndGroomSection(
                    textColor,
                    imageHeight,
                    imageWidth,
                    decorationSize,
                    decorationSizeX2,
                    safeEntered
                )
            }
            // 2
            stickyHeader {
                val infoTitle = when (visibleItemIndex) {
                    in 0..<5 -> InfoSection.Gallery
                    in 5..<10 -> InfoSection.WeddingInfo
                    else -> InfoSection.GiftAndWish
                }

                val isSticky = visibleItemIndex > 1

                InfoTitle(
                    wonderColor = bgColor,
                    infoSection = infoTitle,
                    isSticky = isSticky
                )
            }
            // Gallery
            // 3
            surfaceItem(showGalleryBg) {
                ParallaxImages(
                    parallaxProgress = parallaxProgress,
                    topImagePath = Res.drawable.photo_3,
                    bottomImagePath = Res.drawable.photo_4,
                )
            }
            // 4
            surfaceItem(showGalleryBg) {
                Column {
                    Spacer(Modifier.height(8.dp))
                    RomanticGalleryButton("Lihat Galeri") {
                        openGalleryScreen()
                    }
                }
            }
            // 5
            surfaceItem(showGalleryBg) {
                CompassDivider(
                    Modifier.padding(horizontal = 16.dp, vertical = 72.dp),
                    isExpanded = true
                )
            }
            // Wedding Info
            // 6
            surfaceItem {
                WeddingTitle("Save The Date")
            }
            // 7
            surfaceItem {
                CountdownWedding(year = 2026, month = 4, day = 5, hour = 8, minute = 0)
            }
            // 8
            surfaceItem {
                PullQuote1(
                    bgImage = Res.drawable.photo_2,
                    pullQuote1Progress = 0.02f
                )
            }
            // 9
            surfaceItem {
                PullQuote1(
                    bgImage = Res.drawable.photo_2,
                    pullQuote1Progress = 0.02f,
                    list = getUnduhMantu()
                )
            }
            // 10
            surfaceItem {
                CompassDivider(
                    Modifier.padding(horizontal = 16.dp, vertical = 72.dp),
                    isExpanded = true
                )
            }
            // Wishes And Gift
            // 11
            surfaceItem {
                WishesSection(repo = invitationRepo, name = invitationName)
            }
            // 12
            surfaceItem {
                WishesListSection(repo = invitationRepo)
            }
            // 13
            surfaceItem {
                CompassDivider(
                    Modifier.padding(horizontal = 16.dp, vertical = 72.dp),
                    isExpanded = true
                )
            }
            // Footer
            // 14
            surfaceItem {
                WeddingClosing(textColor)
            }
        }
    }
    if (uiScrollState.firstItemProgress < 0.6f) {
        AppIconButton(
            Res.drawable.icon_next,
            contentDescription = stringResource(Res.string.semanticsNext),
            onClick = backToGate,
            modifier = Modifier
                .rotate(-90f)
                .padding(16.dp).align(alignment = Alignment.TopEnd)
        )
    }
    WeddingFloatingButton(audioPlayer)
}